import styled from 'styled-components';
import { variables } from 'styledComponents/utils';

const Card = styled.div`
  background-color: white;
  width: 100%;
  padding: 20px;
  cursor: pointer;
  margin-bottom: 25px;

  ${props => props.medCheckout && 'padding: 0;'}

  ${props => props.outline ? `
    box-shadow: 0 0 0 3px ${variables.lineColor};
  ` : null }

  ${props => props.selected ? `
    box-shadow: 0 0 0 3px ${variables.yellow};
    background-color: ${variables.yellow};
  ` : null
}

  ${props => props.darkMode ? `
    background-color: rgb(243, 241, 240);
  ` : null}

  & > div {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }
  & > div:first-of-type {
    padding-top: 0;
  }
  & > div:last-of-type {
    padding-bottom: 0;
  }

  .edit {
    text-transform: lowercase;
    font-size: .75rem;
    color: ${variables.midGrey};
    border-bottom: 1px solid ${variables.midGrey};
    cursor: pointer;
    &:hover {
      color: ${variables.darkGrey};
      border-bottom-color: ${variables.darkGrey};
    }
  }
  .payment-account {
    color: ${variables.midGrey};
    font-size: .875rem;
  }
`

const NewCheckoutCard = styled.div`
  position: relative;
  background-color: white;
  width: 100%;
  padding: 0px;
  cursor: pointer;
  margin-bottom: 0;

  ${props => props.outline ? `
    box-shadow: 0 0 0 3px ${variables.lineColor};
  ` : null }

  ${props => props.selected ? `
    box-shadow: 0 0 0 3px ${variables.yellow};
    background-color: ${variables.yellow};
  ` : null
}

  ${props => props.darkMode ? `
    background-color: rgb(243, 241, 240);
  ` : null}

  & > div {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }
  & > div:first-of-type {
    padding-top: 0;
  }
  & > div:last-of-type {
    padding-bottom: 0;
  }

  p {
    line-height: 22px;
    font-size: 14px;
    color: ${variables.midGrey};
    margin-top: 0;
  }

  .edit {
    font-size: 14px;
    color: ${variables.midGrey};
    border-bottom: 1px solid ${variables.midGrey};
    position: absolute;
    cursor: pointer;
    top: -30px;
    right: 0;
    &:hover {
      color: ${variables.darkGrey};
      border-bottom-color: ${variables.darkGrey};
    }
  }
`;

export const PrepayCard = styled.div(({
	theme,
}) => ({
	display: 'flex',
	justifyContent: 'space-between',
	cursor: 'pointer',

	borderColor: theme.neutrals[300],
	borderWidth: 1,
	borderStyle: 'solid',
	borderRadius: 8,

	padding: 16,
	marginBottom: 12,

	svg: {
		marginRight: 10,
		verticalAlign: 'middle',
	},
}))

export {
	Card,
	NewCheckoutCard,
}
